import styled, { css, keyframes } from "styled-components";

const slideInFromBottom = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0%);
    opacity: 1;
  }
`;

const slideOutToBottom = keyframes`
  from {
    transform: translateY(0%);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;

interface AnimatedModalProps {
  isVisible: boolean;
  isAnimating: boolean;
}

export const AnimatedModal = styled.div<AnimatedModalProps>`
  width: 552px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;
  top: 0.9%;
  right: 1.7%;
  width: 552px;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transition: opacity 0.5s ease;
  ${(props) =>
    props.isAnimating &&
    css`
      animation: ${slideInFromBottom} 1.5s ease-in-out;
    `}
  ${(props) =>
    !props.isVisible &&
    props.isAnimating &&
    css`
      animation: ${slideOutToBottom} 1.5s ease-in-out forwards;
    `}
      @media only screen and (max-width: 767px) {
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
  }
`;

export const ShareLinkImg = styled.img`
  /* animation: ${slideInFromBottom} 1.5s ease-in-out; */
  @media only screen and (max-width: 767px) {
    display: none;
  }
  @media only screen and (min-width: 767px) and (max-width: 1024px) {
  }
`;

export const ShareLinkMobileImg = styled.img`
  display: none;
  @media screen and (max-width: 320px) {
    display: flex;
    width: 285px;
    position: absolute;
    right: -1%;
    top: -1.5%;
    border-radius: 20px;
  }
  @media only screen and (min-width: 321px) and (max-width: 767px) {
    display: flex;
    width: 309px;
    height: 728px;
    position: absolute;
    right: -1%;
    top: -1.5%;
    border-radius: 20px;
  }
`;

export const SendMobileImg = styled.img`
  display: none;
  @media screen and (max-width: 320px) {
    display: flex;
    width: 285px;
    height: 728px;
    position: absolute;
    right: -1%;
    top: -1.5%;
    border-radius: 20px;
  }
  @media only screen and (min-width: 321px) and (max-width: 767px) {
    display: flex;
    width: 309px;
    height: 728px;
    position: absolute;
    right: -1%;
    top: -1.5%;
    border-radius: 20px;
  }
`;

export const SendImg = styled.img`
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;
